export const headerAgencyActivityDetailTable = [
  {
    headerStyles: 'w-[10%] font-semibold py-5 px-4',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'Retry number',
    label: 'retry_number',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[10%] font-semibold py-5 px-4',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'Status',
    label: 'status',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[10%] font-semibold py-5 px-4',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'Is Processed',
    label: 'is_processed',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[30%] font-semibold py-5 px-4',
    rowWid: 'w-[30%] py-5 break-all pl-4 align-top',
    name: 'Error',
    label: 'error',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[20%] font-semibold py-5 px-4',
    rowWid: 'w-[20%] py-5 break-all align-top pl-4',
    name: 'Created At',
    label: 'created_at',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[15%] font-semibold py-5 px-4',
    rowWid: 'w-[15%] py-5 break-all align-top pl-4',
    name: 'Next Retry Second',
    label: 'next_retry_second',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },

]
